// Cores de marca/visual do PGR Bradesco — única fonte, reutilizada pelo cabeçalho, capa,
// títulos de seção e tabelas (evita o mesmo hex duplicado em vários arquivos de seção).
//
// Valores confirmados por inspeção pixel-a-pixel do PDF-modelo real ("Modelo PGR 2026 -
// Banco Bradesco_Varejo"), renderizado página a página.
//
// HISTÓRICO da cor de título/subtítulo/rótulo "rótulo: valor" (import ante de reverter,
// ver PR #728): o modelo real usa um azul petróleo escuro (`HEADING_COLOR`, `#0F4761`)
// nesses três níveis — confirmado por amostragem de pixel em várias páginas (ex.: "4.
// DIREITOS E DEVERES", "5.2.1. Classificação dos Riscos Biológicos", "Sumário", a caixa
// "1.1. Identificação da Unidade"), sempre o mesmo RGB(15,71,97). Julia (PM) pediu em um
// primeiro momento para usar o vermelho da marca (`BRADESCO_RED`) nesses lugares em vez do
// que o modelo mostra, e o PR foi atualizado nesse sentido — depois, ao revisar o modelo
// novamente, ela confirmou priorizar o que o PDF-modelo real mostra sempre que houver
// conflito. Por isso `HEADING_COLOR` foi restaurado e os usos de título/subtítulo/rótulo
// voltam a usá-lo. `BRADESCO_RED` continua sendo a cor correta (confirmada no modelo) para
// bordas de tabela, cabeçalho das tabelas em grade e a página de rosto do logo — não muda.
// Uma exceção pontual: o título "RESPONSÁVEIS TÉCNICOS" (Seção 20) é preto no modelo real,
// não azul petróleo nem vermelho — ver `20.ConsideracoesFinaisSection.js`.
export const BRADESCO_RED = '#CC092F' // vermelho do logo Bradesco — bordas/cabeçalhos de tabela em grade.
export const HEADING_COLOR = '#0F4761' // azul petróleo do modelo real — títulos/subtítulos de seção e rótulos "rótulo: valor".
export const TABLE_BORDER_RED = '#FF0000' // borda e preenchimento do cabeçalho das tabelas em grade do modelo.
export const TABLE_ACCENT_DARK_RED = '#C00000' // barra "Severidade"/"Probabilidade" da Matriz de Risco.
export const TABLE_STRIPE_TINT = '#FAE2D5' // realce (zebra) das linhas ímpares das tabelas em grade do modelo.

// Cores de preenchimento da Matriz de Risco (heat-map), por classificação — mesmos rótulos
// de `classificacao` retornados por `_helpers/riskEngine.js` (MATRIZ_RISCO). Puramente
// apresentacional: não altera nenhum valor/ID calculado, só a cor de fundo da célula.
export const RISCO_CELL_COLORS = {
  Trivial: '#4C94D8',
  Baixo: '#8ED873',
  Moderado: '#FFFF00',
  Alto: '#FFC000',
  Crítico: '#FF0000'
}

// Cores da coluna "Classificação" da tabela 9.4 "Avaliação e Prioridade de Controle" —
// confirmadas por amostragem de pixel do recorte do modelo enviado por Julia Buzzo
// (reporte de bug: a coluna não tinha nenhuma cor, ficava em branco/zebrado). Valores
// distintos dos de `RISCO_CELL_COLORS` (tabela diferente, o modelo real usa tons
// levemente diferentes entre a Matriz de Risco e esta tabela) — não reaproveitar um pelo
// outro. `text` só é definido quando difere do preto padrão (caso do Crítico, fundo
// vermelho escuro igual ao cabeçalho `TABLE_ACCENT_DARK_RED`).
export const PRIORIDADE_CONTROLE_COLORS = {
  Trivial: { bg: '#00B0F0' },
  Baixo: { bg: '#8ED873' },
  Moderado: { bg: '#FFFF00' },
  Alto: { bg: '#FFC000' },
  Crítico: { bg: TABLE_ACCENT_DARK_RED, text: '#FFFFFF' }
}
